import { inject, NgModule, provideAppInitializer, ErrorHandler } from '@angular/core';
import { take } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { AppComponent } from './app.component';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSelectModule } from '@angular/material/select';
import { MatListModule } from '@angular/material/list';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { API_BASE_URL } from './api';
import { AppConfigService } from './AppConfigService';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IdentityAuthService } from './_services/identity-auth.service';
import { AuthGuard } from './identity/authGuard';
import { Router } from '@angular/router';
import { AuthInterceptor } from './identity/interceptor';
import { AppRoutingModule } from './app-routing.module';
import { HomeComponent } from './Home/home.component';
import { DialogContainerDirective, DialogContainerService, DialogModule, DialogService, WindowModule, WindowService } from '@progress/kendo-angular-dialog';
import { IdentityModule } from './identity/identity.module';
import { KendoAlertService } from '@ticomix/angular-kendo';
import { TokenInterceptor } from './Ticomix/token.interceptor';
import { GridRightClickMenuModule } from '@ticomix/angular-kendo';
import { MatMenuModule } from '@angular/material/menu';
import { MatIconModule } from '@angular/material/icon';
import { PendingChangesGuard } from '@ticomix/angular-common';
import { StandaloneService } from './standalone.service';
import { GlobalErrorHandler } from './_services/global-error-handler';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    ReactiveFormsModule,
    AppRoutingModule,
    DialogModule,
    WindowModule,
    MatToolbarModule,
    MatButtonModule,
    MatSidenavModule,
    MatSelectModule,
    MatListModule,
    IdentityModule,
    GridRightClickMenuModule,
    MatMenuModule,
    MatIconModule
  ],
  providers: [
    provideAnimationsAsync(),
    provideAppInitializer(() => {
      const appConfigService = inject(AppConfigService);
      // Return a function that returns the Observable promise
      return appConfigService.getConfig();
    }),
    {
      provide: API_BASE_URL, useValue: "."
    },
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: TokenInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useFactory: (router: Router) => {
        return new AuthInterceptor(router);
      },
      multi: true,
      deps: [Router]
    },
    AuthGuard,
    PendingChangesGuard,
    IdentityAuthService,
    KendoAlertService,
    PendingChangesGuard,
    StandaloneService,
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
